module.exports = __webpack_public_path__ + "static/media/dashboard-cards.a2d8b435.jpg";